import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getPricingByCurrency} from 'utils/getPricingByCurrency'

type Props = {
  option: Ventrata.Option
  currency: Basic.Currency
  calendarDay: Ventrata.CalendarDay | null
}

export const CostFromPerBooking = ({option, currency, calendarDay}: Props) => {
  const pricingSource = calendarDay ? calendarDay.pricingFrom : option.pricingFrom
  const amount = getPricingByCurrency(pricingSource, currency)?.retail

  if (amount === undefined) {
    return <div className="font-medium text-red-500">No pricing found for currency: {currency}</div>
  }

  return <div className="text-end">{formatMoney(amount, currency)}/booking</div>
}
